import React, { useState } from "react";
import ExcelUploader from '../common/ExcelUploader';
import { useApi } from './../../hooks/useApi';
import { toast } from 'react-toastify';
import * as XLSX from "xlsx";

function excelDateToISO(excelDate) {
  if (!excelDate || typeof excelDate !== 'number') return null;
  const date = new Date(Math.round((excelDate - 25569) * 86400 * 1000));
  return date.toISOString().split("T")[0]; 
}

function downloadTemplate() {
  const headers = [
    "chainId",
    "customer",
    "product",
    "qty",
    "active",
    "dateStart",
    "dateEnd",
  ];

  const ws = XLSX.utils.aoa_to_sheet([headers]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Plantilla");
  XLSX.writeFile(wb, "plantilla_maximos.xlsx");
}

function App() {
  const { post } = useApi();
  const [excelData, setExcelData] = useState([]);

  const handleData = (data) => {
    setExcelData(data);
  };

  const handleSend = async () => {
    if (excelData.length === 0) {
      toast.error("No hay datos para enviar");
      return;
    }

    const payload = {
      data: excelData.map(item => ({
        chaindId: Number(item.chainId),
        customer: String(item.customer),
        product: String(item.product),
        qty: Number(item.qty),
        active: Number(item.active),
        dateStart: excelDateToISO(item.dateStart),
        dateEnd: excelDateToISO(item.dateEnd),
      }))
    };

    try {
      const response = await post('enviaMaximos', payload);
      if (response) {
        toast.success("Operación exitosa");
        setExcelData([]); // limpia datos tras envío
      }
    } catch {
      toast.error("Error al enviar los datos");
    }
  };

  const handleClear = () => {
    setExcelData([]);
  };

  return (
    <div className="lg:col-span-8 col-span-12">
      <h1 className="text-xl font-bold mb-4">Máximos de productos</h1>

      <ExcelUploader
        onDataLoaded={handleData}
        // requiredColumns={["chainId", "customer", "product", "qty", "active", "dateStart", "dateEnd"]}
      />

      {excelData.length > 0 && (
        <div className="mt-4 flex gap-3">
          <button
            className="bg-green-600 text-white px-4 py-2 rounded"
            onClick={handleSend}
          >
            Enviar a servidor
          </button>
          <button
            className="bg-gray-600 text-white px-4 py-2 rounded"
            onClick={handleClear}
          >
            Limpiar datos
          </button>
          <button
            className="bg-blue-600 text-white px-4 py-2 rounded"
            onClick={downloadTemplate}
          >
            Descargar plantilla
          </button>
        </div>
      )}
    </div>
  );
}

export default App;
